import { render, staticRenderFns } from "./ErrorsListModal.vue?vue&type=template&id=2ea5c2bf"
import script from "./ErrorsListModal.vue?vue&type=script&lang=js"
export * from "./ErrorsListModal.vue?vue&type=script&lang=js"
import style0 from "./ErrorsListModal.vue?vue&type=style&index=0&id=2ea5c2bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports